import { getSelectedTableView } from 'owa-mail-list-store';
// Gets the MailList Loading, loaded, Error states
export default function getMailListLoadState() {
    var tableView = getSelectedTableView();
    if (!tableView || !tableView.isInitialLoadComplete) {
        return 1 /* Loading */;
    }
    var isTableEmpty = tableView.rowKeys.length == 0;
    // do not display error if there're cached items in the table to show;
    // when error occurs and the table is truly empty, prioritize showing error instead
    // of no items in the list view
    if (tableView.loadErrorStatus != 0 /* None */ && isTableEmpty) {
        return 3 /* Error */;
    }
    if (isTableEmpty) {
        return 2 /* Empty */;
    }
    return 0 /* Loaded */;
}
//# sourceMappingURL=getMailListLoadState.js.map